import { FieldError } from "@pdfking/components"
import type { ValidationError } from "@pdfking/forms"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"

import { useTranslation } from "../../i18n/useTranslation"

export const DjErrors = CreateRenderFunction({
  props: {
    error: undefined as ValidationError | undefined,
  },
  render(children) {
    const forms = useTranslation("forms")
    const description = this.error && forms[this.error.enum]?.(this.error)
    return (
      <>
        {children}
        {description && <FieldError>{description}</FieldError>}
      </>
    )
  },
})
